module.exports = __webpack_public_path__ + "static/UNB-e39c5d8565e6ce9519988897eef3cb25.woff";